<template>
  <div />
</template>

<script>
import firebase from '@/firebase.config'

export default {
  name: 'Logout',
  data() {
    return {}
  },
  async created() {
    await firebase.auth().signOut()

    // Report to GA
    firebase.analytics().logEvent('logout')

    this.$store.dispatch("clearAuthUser")
    // Display a snackbar message
    this.$store.dispatch('storeSnackbarMessage', 'You have logged out')
    this.$router.push({ name: 'Home'})
  }
}
</script>